/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["hr[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0}.col-sm-2[_ngcontent-%COMP%], .col-xs-2[_ngcontent-%COMP%]{padding-left:0}.col-sm-10[_ngcontent-%COMP%], .col-xs-10[_ngcontent-%COMP%]{padding-right:0}.vip-header[_ngcontent-%COMP%]   .header-logo[_ngcontent-%COMP%] > a[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:221px}"];
export { styles as styles };
